import React from 'react';

import styles from './returnsStyles';

import Table from 'buyside/components/presentation/Table/table';
import DocumentList from 'buyside/components/presentation/DocumentList/documentList';

import { employerProfileDocumentUrl } from 'buyside/util/urlHelper';
import { formatDate } from 'buyside/util/dateHelper';

const Returns = ({ fundProfile }) => {
  const { name: fundName, returns, returnsUpdatedDate, returnsDocuments } = fundProfile;
  const retAttrs = [
    'ytd',
    'ltm',
    'oneYear',
    'threeYear',
    'fiveYear',
    'sevenYear',
    'tenYear',
    'sinceInception'
  ];
  return (
    <div>
      <Table
        headings={['YTD', 'LTM', '1 Yr', '3 Yr', '5 Yr', '7 Yr', '10 Yr', 'Inception']}
        items={returns}
        getItemMainAttr={ret => {
          if (ret.employerBenchmark)
            return (
              <div className={styles.returnStrategyName}>
                <p>{fundName}</p>
                {fundName === ret.benchmark ? null : <p>{ret.benchmark}</p>}
              </div>
            );

          return ret.benchmark;
        }}
        getItemAttrs={ret =>
          retAttrs.map(attr => ret[attr] && `${ret[attr].toFixed(ret[attr] >= 100 ? 0 : 1)}%`)
        }
        entryClassName={styles.returnsTableEntry}
        noEntryClassName={styles.returnsTableNoEntry}
        rowHeight="large"
      />
      <div className={styles.returnsFooter}>
        Annualized Returns Only. Returns valid as of {formatDate(returnsUpdatedDate)}.
      </div>
      {!!returnsDocuments.length && (
        <DocumentList
          title="Supporting Documents"
          documents={returnsDocuments}
          urlFn={employerProfileDocumentUrl}
        />
      )}
    </div>
  );
};

export default Returns;
